<template>
  <div v-loading="isLoading" class="courses-container">
    <img
      style=" border-radius: 15px;"
      @click="handlePlayVideo"
      v-if="!isShowVideo"
      :src="img.VideoPoster"
      alt=""
    />
    <video
      class="video"
      style="height: 380px; border-radius: 15px; background: black;"
      v-if="isShowVideo"
      autoplay
      ref="videoRef"
      @ended="handleVideoEnd"
      :src="dataObject.url_link"
      width="100%"
      controls
    ></video>
  </div>
</template>
<script>
import VideoPoster from "@/assets/img/img_edu/Video.png";
import { isEmpty } from "@/utils/validate";

export default {
  name: "video-detail-courses",
  props: {
    dataObject: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {},
  created() {},
  data() {
    return {
      url_link: '',
      isShowVideo: false,
      isLoading: false,
      img: {
        VideoPoster
      }
    };
  },
  watch: {
    dataObject(val) {
      console.log('vào đây__', val, this.$refs.videoRef);
      if (!isEmpty(val)) {
         if (this.$refs.videoRef) {
          this.$refs.videoRef.pause();
          this.$refs.videoRef.currentTime = 0;
          // this.$refs.videoRef.src = ''; // Clear the current src
        }
        this.isLoading = val.isLoading || false
        this.isShowVideo = val.isShow;
      }
    }
  },
  methods: {
    handleVideoEnd() {
      this.isShowVideo = false;
    },
    handlePlayVideo() {
      if (!this.dataObject.url_link) {
        this.$message.warning("Please select a lesson to view.");
        return;
      }
      this.isShowVideo = true;
    }
  }
};
</script>
<style scoped>

.courses-container {
  margin-right: 0px;
}
.main-view {
  padding-top: 100px;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .video {
    height: 300px !important;
  }
}
</style>
